const http = {
    upload: 'http://cdimage.centaline.com.cn:2001',
	logInfo:'http://sc18006783.centaline-sc.com'
}
export default http;